/**
 * EventTableHead
 */
import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TableHeadTableCell from '../../../../../../../../components/TableHeadTableCell';

export default class EventTableHead extends React.PureComponent<*> {
    render() {
        return (
            <Table.Header
                // HACK inline styles
                style={{
                    fontSize: 14
                }}
            >
                <Table.Row>
                    <TableHeadTableCell
                        label="Area"
                        value="entity.pathNames"
                        defaultSort="entity.pathNames"
                    />
                    <TableHeadTableCell label="Lot" value="entity.name" />
                    <TableHeadTableCell
                        label="Pick #"
                        value="harvestEvent.pickType.name"
                    />
                    <TableHeadTableCell
                        label="Variety"
                        value="entity.variety.name"
                    />
                    <TableHeadTableCell
                        label="Forecasted Bins"
                        value="forecastedQuantity"
                    />
                    <TableHeadTableCell />
                </Table.Row>
            </Table.Header>
        );
    }
}
